module.exports = __webpack_public_path__ + "static/facebook-6163476d4921dbaf83480bfe4690fb4e.png";